/*
** This file starts the scrolling image panel - if it exists
*/
export function enable() {
    console.log("scroller.enable called");
    var ims = document.querySelectorAll("#scroller > span > img");
    var nbr_images = ims.length;
    if(nbr_images ==0) {
        console.log("scroller nothing to do")
        return
    }
    var index = 0;
    for(let i = 0; i < nbr_images; i++) {
        ims[i].style.display = "none";
    }
    ims[0].style.display="block";
    ims[0].style.opacity = 0.1;
    ims[3].style.display="block";
    ims[3].style.opacity = 0.9;
    looper(ims);
}

function looper(images) {
    let fade_ms = 5;
    let delta = 0.0025
    let nbr = images.length;
    let current_index = 0;
    let old_index = nbr - 1;
    images[current_index].style.opacity = "1"
    images[current_index].style.display = "block"
    for(let i = 1; i < nbr; i++) {
        images[i].style.display = "none";
        images[i].style.opacity = "0"
    }
    // console.log("looper starting");
    delay();
    function delay()
    {
        setTimeout(function(){
            //compute current
            // console.log("delay calling fadeOut")
            fadeOut();
        }, 5000);
    }
    function fadeOut() {
        // console.log("fadeOut entered")
        old_index = current_index;
        current_index = (current_index + 1) % nbr;
        let opacity = 1.0
        let interval_timer = setInterval(function fadeOut_done() {
            // console.log("fadeOut interval callback", old_index, current_index)
            opacity -= delta
            images[old_index].style.opacity = `${opacity}`;
            let done = opacity <= 0.0; 
            if(done) {
                clearInterval(interval_timer);
                images[current_index].style.opacity = "0.0"
                images[current_index].style.display = "block"
                images[old_index].style.display = "none";
                fadeIn();
            }
        }, fade_ms)
    }
    function fadeIn() {
        let opacity = 0.0
        let interval_timer = setInterval(function fadeOut_done() {
            opacity += delta
            // console.log(`fadeIn opacity: ${opacity}`)
            images[current_index].style.opacity = `${opacity}`
            let done = opacity >= 1.0
            if(done) {
                clearInterval(interval_timer);
                delay();
            }
        }, fade_ms*2)
    }
}
